import useMutationEmailOption from './email-use-mutation-rule';



export const emailUseMutation = {
  option: useMutationEmailOption,
}